import React from 'react';

function MenuItems(props) {
  return (
    <div
      key={props.i}
      className="kupos-card account-general-item pointer"
      onClick={
        props.val.label == 'MY_QR'
          ? props.data.loginData && props.data.loginData.identity_type == 7
            ? () => props.onItemClick(props.val, props.i)
            : () => {
                // this.setState({
                //   showSuccessFailureModal: true,
                //   showSuccessFailureModalStatus: false,
                //   showSuccessFailureModalBodyText: this.props.t('PROFILE.FUNCTIONALITY_FOR_RUT'),
                // });
                props.setShowSuccessFailureModal(true);
                props.setShowSuccessFailureModalStatus(false);
                props.setShowSuccessFailureModalBodyText(props.t('PROFILE.FUNCTIONALITY_FOR_RUT'));
              }
          : () => props.onItemClick(props.val, props.i)
      }
    >
      <div className={'account-general-image-item '}>
        <img src={props.val.icon} alt="" />
      </div>
      <div>{props.t('PROFILE.' + props.val.label)}</div>
    </div>
  );
}

export default MenuItems;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyAccount/components/MenuItems.js